import { ILayerController, LayerControllerService } from '@addins/core/map';
import { Injectable } from '@angular/core';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { Map as SagaMap } from '@techwan/mapping';
import { DeploymentsLayerService } from '../../deployments-layer/deployments-layer.service';
import { MyDeploymentLayerService } from '../../my-deployment-layer/my-deployment-layer.service';
import { MyDeploymentToggleButtonControllerService } from '../../my-deployment-toggle-button-controller/my-deployment-toggle-button-controller.service';

export interface IDeploymentLayerController {
  onMapAdded(map: SagaMap);
  onMapRemoved();
}

@AddinExecute({
  name: 'deployment-layers-controller'
})
@Injectable()
export class DeploymentsLayerControllerService extends Execute implements ILayerController {
  private _sagaMap: SagaMap = null;

  constructor(
    private layerController: LayerControllerService,
    private deploymentsLayer: DeploymentsLayerService,
    private myDeploymentLayer: MyDeploymentLayerService,
    private myDeploymentToggleButtonController: MyDeploymentToggleButtonControllerService
  ) {
    super();
  }

  execute() {
    this.layerController.addController(this);
  }

  mapDidChange(map: SagaMap) {
    if (map && this._sagaMap === null) {
      this._sagaMap = map;

      this.deploymentsLayer.onMapAdded(map);
      this.myDeploymentLayer.onMapAdded(map);
      this.myDeploymentToggleButtonController.init();
    } else if (!map) {
      this._sagaMap = null;

      this.deploymentsLayer.onMapRemoved();
      this.myDeploymentLayer.onMapRemoved();
      this.myDeploymentToggleButtonController.uninit();
    }
  }
}
